import { TrialBand } from './trialDayBand';

/**
 * i18n key suffixes for the mascot's witty messages, grouped by trial day-band.
 * Keys are relative to the `billing.mascot` namespace.
 */
const MESSAGE_KEYS: Record<TrialBand, readonly string[]> = {
  'first-day': ['early.0', 'early.1', 'early.2', 'early.3'],
  exploring: ['early.0', 'early.1', 'early.2', 'early.3'],
  ending: ['ending.0', 'ending.1', 'ending.2'],
};

/**
 * All message keys available for a trial day-band. Pure.
 */
export const mascotMessageKeys = (band: TrialBand): readonly string[] =>
  MESSAGE_KEYS[band];

/**
 * Picks one mascot message key for a band, deterministically from `seed` (the
 * trial day number) so it stays stable within a day but varies across the
 * trial. Pure — no randomness.
 *
 * @param band The trial day-band to pick a message for.
 * @param seed Stable per-day seed (the trial day number) selecting the message.
 * @returns The chosen i18n key suffix, relative to the `billing.mascot` namespace.
 */
export const mascotMessageKey = (band: TrialBand, seed: number): string => {
  const keys = MESSAGE_KEYS[band];
  const index = ((seed % keys.length) + keys.length) % keys.length;

  return keys[index];
};
